var map = {
	"./10nelly.png": 8747,
	"./1alex.png": 4591,
	"./2bernd.png": 3735,
	"./3beyrle.png": 2210,
	"./4celina.png": 3488,
	"./5christian.png": 2014,
	"./6Fello.png": 8964,
	"./7keks.png": 8303,
	"./8lara.png": 1404,
	"./9manuel.png": 505,
	"./Beelzebub_2013.jpg": 3191,
	"./Beelzebub_2016.jpg": 1134,
	"./Beelzebub_2017.jpg": 9179,
	"./Beelzebub_2018.jpg": 7568,
	"./Beelzebub_2019.jpg": 6141,
	"./Beelzebub_2020.jpg": 5561,
	"./Beelzebub_2026.jpg": 263,
	"./FelsenteufelAnonym.png": 6450,
	"./FelsenteufelRB.png": 1318,
	"./Galerie.svg": 2737,
	"./Karch1_Nebel.png": 7909,
	"./Karch2_Teufel_auf_Karch.png": 6492,
	"./Karch3_Stangen.png": 9349,
	"./Karch4_Bühl_Johannesplatz.png": 2586,
	"./Karch5_Konfettikanone.png": 227,
	"./Maske.png": 2615,
	"./MystischerWald.webp": 9539,
	"./PosterFT.png": 7641,
	"./PosterFTschrift.png": 4218,
	"./PosterFTschriftV2.png": 9862,
	"./Teufelsball2026.jpeg": 6810,
	"./arrow1.svg": 8550,
	"./arrow2.svg": 4773,
	"./contact-img.svg": 9636,
	"./facebookicon.svg": 2449,
	"./gertelbacherwasserfaelle.png": 7380,
	"./haesErklaerung.png": 6637,
	"./instaIcon.svg": 6972,
	"./kampangenplan2026.jpeg": 3458,
	"./straßenbild.png": 8117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8652;